
import arCommon from './ar/common';

const messages = {
  ar: {
    translation: arCommon,
  },
};

export default messages;
